import React from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont'
import { BlackMask } from '../../../../components/mask'
import BottomToTop from '../../../../components/transitions/bottom-to-top'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import { useMemo } from 'react'
import moment from 'moment'
import { BigButton } from '../../../../desktop/components/button'
import { useState } from 'react'
import { useCallback } from 'react'
import { unitPrice } from '../../../../../utils/product'
import { useSelector } from 'react-redux'
// import useCheckout from '../../pages/bag/hooks/checkout'
import { useLogin } from '../../../../hooks/common'
import CountDown from "../../../../components/count-down";

export const Coupon = props => {
    useStyles(classes)
    const { couponVO,onClick,quickBuy } = props
    const { isAvailable, coupon } = couponVO;

    const couponName = useMemo(() => {
        if (coupon?.name) {
            return coupon.name.indexOf('R$') != -1 && coupon.name.indexOf('.') != -1 ? String(coupon.name || '').replace(".", ",") : coupon.name;
        }
    }, [coupon]);

    return <div className={classes.CouponItem}>
        <div className={`${classes.Coupon} ${isAvailable ? '' : classes.DisabledCoupon}`}>
            <div className={classes.DiscountCon}>
                {
                    couponName && <p className={classes.ItemTitle}>{couponName}</p>
                }

                {
                    coupon?.condition && <p className={classes.Desc1}>
                        <span dangerouslySetInnerHTML={{ __html: coupon.condition }}></span>
                    </p>
                }

                {
                    coupon?.description && <p className={classes.Desc1}>
                        <span dangerouslySetInnerHTML={{ __html: coupon.description }}></span>
                    </p>
                }

                {
                    isAvailable&&coupon?.infoMsg && <p className={classes.Desc2}>
                        <span dangerouslySetInnerHTML={{ __html: coupon.infoMsg }}></span>
                    </p>
                }
            </div>

            <div className={classes.MeetCon}>
                {
                    coupon?.willExpires&&coupon?.endDate&&
                    <CountDownPart
                        date={coupon.endDate}
                    />
                }
                {
                    !coupon?.willExpires&&coupon?.beginDate && coupon?.endDate && <p className={classes.Desc1}>
                        <span className={classes.Dot}>.</span>
                        <span>{moment(coupon.beginDate).format('DD/MM/YYYY HH:mm')}~{moment(coupon.endDate).format('DD/MM/YYYY HH:mm')}</span>
                    </p>
                }

                {
                    coupon?.usageReminder && <p className={classes.Desc1}>
                        <span className={classes.Dot}>.</span>
                        <span>{coupon.usageReminder}</span>
                    </p>
                }
            </div>
        </div>
        {
            !isAvailable&&coupon?.infoMsg&&!quickBuy && <div className={classes.UnAvailableInfoMsg}>
                <p className={classes.infoMsg}>
                    <span dangerouslySetInnerHTML={{ __html: coupon.infoMsg }}></span>
                </p>
                <button className={classes.ShopButton} onClick={onClick}><FormattedMessage id="shop" defaultMessage="shop" /></button>
            </div>
        }
    </div>
}

const CountDownPart = props => {
    useStyles(classes)
    const {date} = props
    const now = Date.now();
    const diff = date - now;
    return <div className={classes.CountDownBox}>
        <span className={classes.Expiresin}><FormattedMessage id="expires_in" defaultMessage="Expires in" /></span>
        <CountDown
            showDay={true}
            showHour={true}
            offset={diff}
            numberClass={classes.numberClass}
        />
        {/*<span className={classes.CountDownText}><FormattedMessage id="ends_today" defaultMessage={"ends today"}/></span>*/}
    </div>
}
export const SelectableCoupon = props => {
    useStyles(classes)
    const { couponVO, selected, onSelect,onClick,quickBuy } = props
    const { isAvailable,coupon } = couponVO;
    return <div className={classes.SelectableCoupon} onClick={e => onSelect(!selected? couponVO.coupon?.id: null)}>
        <Coupon couponVO={couponVO} onClick={onClick} quickBuy={quickBuy} />
        {
            isAvailable?selected ? <Iconfont className={classes.Icon}>&#xe658;</Iconfont> : <Iconfont className={classes.Icon}>&#xe65a;</Iconfont>:<Iconfont className={classes.DisabledIcon}>&#xe65a;</Iconfont>
        }
        {
            coupon?.willExpires&&<span className={classes.ExpiresSoon}><FormattedMessage id="expires_soon" defaultMessage="Expires soon" /></span>

        }
    </div>
}

const ApplyCoupon = props => {

    const {onCouponCode} = props
    const { checkoutRefreshing } = useSelector(state => state.pageCart)

    const [value, setValue] = useState('')

    const applyHandle = e => {
        e.preventDefault()
        if(value){
            onCouponCode(value)
        }
    }

    return <div className={classes.ApplyCoupon}>
        <div className={classes.ApplyInputCon}>
            <div className={classes.ApplyInput}>
                <div className={classes.Input}>
                    <input value={value} onChange={(e) => setValue(e.target.value)} />
                </div>

                <BigButton className={classes.Button} loading={checkoutRefreshing} onClick={applyHandle}><FormattedMessage id="apply" defaultMessage="Apply" /></BigButton>
            </div>
        </div>
    </div>
}

export const EditableCouponBook = props => {
    useStyles(classes)
    const { coupons, onSelect, selectedCoupon, onCouponCode,onClick,quickBuy } = props

    const [available, unavailabel] = _.reduce(coupons, (result, couponVO, index) => {
        if (couponVO.isAvailable) {
            result[0].push(couponVO)
        } else {
            result[1].push(couponVO)
        }
        return result
    }, [[], []])


    return <div className={classes.CouponBook}>
        <ApplyCoupon onCouponCode={onCouponCode}/>

        {
            available?.length > 0 && <div className={classes.AvailableCouponList}>
                <div className={classes.AvailableTitle}><FormattedMessage id="available" defaultMessage="Available" /></div>

                {
                    available.map(couponVO => <SelectableCoupon key={couponVO.coupon?.id} onSelect={onSelect} couponVO={couponVO} selected={couponVO.coupon?.id === selectedCoupon?.id} quickBuy={quickBuy} />)
                }
            </div>
        }

        {
            unavailabel?.length > 0 && <div className={classes.AvailableCouponList}>
                <div className={classes.AvailableTitle}><FormattedMessage id="not" defaultMessage="Not" /> <FormattedMessage id="available" defaultMessage="Available" /></div>

                {
                    unavailabel.map(couponVO => <SelectableCoupon key={couponVO.coupon?.id} couponVO={couponVO} onClick={onClick} quickBuy={quickBuy} />)
                }
            </div>
        }

    </div>
}

export const ReadOnlyCouponBook = props => {
    useStyles(classes)
    const { coupons, onSelect, selectedCoupon } = props

    const [available, unavailabel] = _.reduce(coupons, (result, couponVO, index) => {
        if (couponVO.isAvailable) {
            result[0].push(couponVO)
        } else {
            result[1].push(couponVO)
        }
        return result
    }, [[], []])

    return <div className={classes.CouponBook}>

        <div className={classes.Attention}>
            <Iconfont className={classes.Icon}>&#xe7be;</Iconfont>
            <div className={classes.Content}>
                <FormattedMessage id="use_following_coupons" defaultMessage={'You can use the following coupons on the items in your shopping cart, please use them on the place order page.'}/>
            </div>
        </div>

        {
            available?.length > 0 && <div className={classes.AvailableCouponList}>
                <div className={classes.AvailableTitle}><FormattedMessage id="available" defaultMessage="Available" /></div>

                {
                    available.map(couponVO => <Coupon key={couponVO.coupon?.id} couponVO={couponVO} />)
                }
            </div>
        }

        {
            unavailabel?.length > 0 && <div className={classes.AvailableCouponList}>
                <div className={classes.AvailableTitle}><FormattedMessage id="not" defaultMessage="Not" /> <FormattedMessage id="available" defaultMessage="Available" /></div>

                {
                    unavailabel.map(couponVO => <Coupon key={couponVO.coupon?.id} couponVO={couponVO} />)
                }
            </div>
        }

    </div>
}


const WrappedEditor = props => {
    useStyles(classes)
    const { pageType, onClose } = props
    const isLogin = useLogin()
    const {
        checkoutRefreshing,
    } = useSelector(state => state.pageCart)

    // const { applyCheckout } = useCheckout()

    // const showHandleCheckout = pageType === 'cart' && isLogin
    const showHandleCheckout = false

    const buttonClickHandle = async () => {
        // if(showHandleCheckout){
        //    await applyCheckout()
        // }
        onClose()
    }
    

    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.CouponContainer}>
            <div>
                <div className={classes.Hd}>
                    <span className={classes.Title}>
                        <FormattedMessage id="my_coupons" defaultMessage="My Coupons" />
                    </span>
                    <Iconfont className={classes.Close} onClick={props.onClose}>&#xe7c9;</Iconfont>
                </div>

                {/* {props?.loginTip} */}

                <div className={`${classes.Bd} ${props.onSelect ? classes.Editable: ''}`}>

                    {
                        props.onSelect ? <EditableCouponBook {...props} /> : <ReadOnlyCouponBook {...props} />
                    }

                </div>

                {
                    props.onSelect && <div className={classes.Fd}>
                        <div className={classes.Summary}>
                            <span><FormattedMessage id="exprct_to_save" defaultMessage="Expect to Save" />:</span>
                            <span>
                                <span className={classes.Red}>{props.couponDiscount ? unitPrice(props.couponDiscount) : ''}</span>
                            </span>
                        </div>

                        <BigButton onClick={buttonClickHandle} className={classes.Button}>
                            {
                                showHandleCheckout ? <FormattedMessage loading={checkoutRefreshing} id="checkout" defaultMessage="CHECKOUT" />: <FormattedMessage id="continue" defaultMessage="Continue" />
                            }
                        </BigButton>
                    </div>
                }
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}


export default props => {

    if (typeof window === 'undefined')
        return null

    return ReactDOM.createPortal(
        <WrappedEditor {...props} />,
        document.getElementById('root')
    )
}